<template>
  <CModal alignment="center" :visible="show" @close="cancel">
    <CModalHeader class="bg-primary">
      <CModalTitle class="text-light fs-6">星級評分設定</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <div v-for="item in selectPattern" :key="item">
        <span class="mx-1">{{ item.label }}</span>
        <CFormSelect
          class="my-2"
          :model-value="item.value"
          @update:modelValue="item.value = $event"
        >
          <option v-for="option in item.options" :key="option">
            {{ option }}
          </option>
        </CFormSelect>
      </div>
    </CModalBody>
    <CModalFooter>
      <CButton color="primary" @click="submit">完成</CButton>
      <CButton color="light" @click="cancel"> 取消 </CButton>
    </CModalFooter>
  </CModal>
</template>
<script>
import { ref } from '@vue/reactivity'
import { watch } from '@vue/runtime-core'
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: null,
    }
  },
  emits: ['close', 'list'],
  setup(props, { emit }) {
    const selectPattern = ref([
      {
        label: '級數',
        options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        value: '5',
      },
      {
        label: '形狀',
        options: ['★ 星星', '♥ 心心', '✔ 勾勾', '👍讚讚'],
        value: '★ 星星',
      },
    ])
    const defaultSelectPattern = JSON.stringify(selectPattern.value)
    const cancel = () => {
      selectPattern.value = JSON.parse(defaultSelectPattern)
      emit('list', selectPattern.value)
      emit('close')
    }
    const submit = () => {
      console.log(selectPattern.value);
      emit('list', selectPattern.value)
      emit('close')
    }
    watch(
      ()=>props.level,
      (newVal)=>{
        console.log(newVal);
        if(newVal){
          selectPattern.value[0].value = String(newVal)
        }
      },
      { immediate: true },

    )
    return { selectPattern, submit, cancel }
  },
}
</script>
<style lang="scss" scoped></style>
